import menuItems from "./menuItems.json";
import { NavLink } from "react-router-dom";
import { useState, useContext, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { LangContext, CanvasContext } from "../App";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";

export default function Menu({ isOpen, changeData }) {
  const [active, setActive] = useState(true);
  const lang = useContext(LangContext);
  const [chooseLang, setChooseLang] = useState("PL");
  const canvas = useContext(CanvasContext);

  const styles = {
    section: {
      backgroundColor: "#f9fafb",
      padding: "80px 16px",
      fontFamily: "sans-serif",
    },
    header: {
      maxWidth: "1300px",
      margin: "0 auto 64px auto",
      textAlign: "center",
    },

    navItemContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
    },

    h2: {
      fontSize: "14px",
      fontWeight: "800",
      color: "#111827",
      margin: 0,
      display: "flex",
      alignItems: "center",
    },
    langText: {
      fontSize: "14px",
      fontWeight: "800",
      color: "#111827",
      margin: 0,
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
    },
  };

  function clickedHandler() {
    const newLang = lang === "pl" ? "en" : "pl";
    changeData(newLang);
    setChooseLang(newLang === "pl" ? "EN" : "PL");
  }

  useEffect(() => {
    if (lang === "pl") {
      setChooseLang("EN");
    }
    if (lang === "en") {
      setChooseLang("PL");
    }
  }, [lang]);

  function handleActive(val) {
    setActive(val);
  }

  return (
    <CanvasContext.Provider value={canvas}>
      <ul className={`main-nav ${isOpen ? "active" : ""}`}>
        {menuItems.map((item, index) => {
          return (
            <li key={item.id} style={styles.navItemContainer}>
              <NavLink
                to={item.name}
                style={{
                  textDecoration: "none",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <h2
                  style={styles.h2}
                  onClick={() => handleActive(item)}
                  className={`nav-item-lato ${active === item ? "active" : ""}`}
                >
                  {index === 0 ? (
                    <HomeOutlinedIcon
                      style={{ display: "block", fontSize: "44px" }}
                    />
                  ) : (
                    <FormattedMessage id={item.name} />
                  )}
                </h2>
              </NavLink>
            </li>
          );
        })}

        <li style={styles.navItemContainer}>
          <p
            className="nav-item-lato"
            onClick={clickedHandler}
            style={styles.langText}
          >
            {chooseLang}
          </p>
        </li>
      </ul>
    </CanvasContext.Provider>
  );
}
